module.exports = __webpack_public_path__ + "img/patent_image1.d9711ef9.png";